import { type BaseSchemes, type Root, Scope } from 'rete'
import { type Area2D } from 'rete-area-plugin'
import { type Connection } from 'rete-connection-plugin'
export class ReadonlyPlugin<Schemes extends BaseSchemes> {
  root = new Scope<never, [Root<Schemes>]>('readonly')
  area = new Scope<never, [Area2D<Schemes>, Root<Schemes>]>('readonly')
  connection = new Scope<never, [Connection, Root<Schemes>]>('readonly')
  enabled = false

  constructor() {
    this.root.addPipe(context => {
      if (!this.enabled) return context
      if (context.type === 'connectionremoved') return
      if (context.type === 'nodecreate') return
      if (context.type === 'connectioncreate') return
      return context
    })
    this.area.addPipe(context => {
      if (!this.enabled) return context
      if (context.type === 'nodetranslate') return
      if (context.type === 'render' && context.data?.type === 'connection') return
      return context
    })
    this.connection.addPipe(context => {
      if (!this.enabled) return context
      if (context.type === 'connectionpick') return
      return context
    })
  }
  public enable() {
    this.enabled = true
  }

  public disable() {
    this.enabled = false
  }
}
